<template>
  <div
    ref="videoContainer"
    class="current-video-media"
  >
    <div class="video-wrapper">
      <iframe
        v-if="parsedVideoSrc"
        :width="width"
        :height="height"
        :src="`${parsedVideoSrc}?autoplay=1`"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        title="Netflix Removed React?"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { StrapiVideoMedia } from '@/services/product/types';
  import { ref, onMounted, onUnmounted, computed } from 'vue';

  const props = defineProps<{
    media: StrapiVideoMedia;
  }>();

  const videoContainer = ref<HTMLElement | null>(null);

  const width = ref(0);
  const height = ref(0);

  const updateDimensions = () => {
    if (videoContainer.value) {
      width.value = videoContainer.value.offsetWidth;
      height.value = width.value * (9 / 16); // 16:9 ratio
    }
  };

  const parsedVideoSrc = computed(() => {
    if (props.media.video) {
      const parsedFromJson = JSON.parse(props.media.video);

      const { html } = parsedFromJson.rawData;

      let src = html.match(/src="([^"]+)"/)?.[1];

      if (src) {
        const url = new URL(src);
        url.searchParams.delete('feature');
        src = url.toString();
      }

      return src;
    }

    return null;
  });

  onMounted(() => {
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateDimensions);
  });
</script>

<style scoped>
  .current-video-media {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .video-wrapper {
    width: 100%;
  }
</style>
